<template>
  <v-layout warp row justify-center>
    <v-dialog v-model="chatdialog_video" @keydown.esc="close_video()" fullscreen>
      <v-card style="background-color: rgba(0, 0, 0, 0.9);">
        <v-layout row wrap style="height: 100vh;" v-if="$vuetify.breakpoint.height > 500 && $vuetify.breakpoint.width > 600">
          <v-layout row justify-center align-center v-for="(item,index) in pathvideo" :key="index">
            <v-flex grow pa-1 style="height: 100vh;">
              <v-btn fab dark small class="CloseIcon" @click="close_video()"><v-icon>close</v-icon></v-btn>
              <v-layout row wrap align-center justify-center fill-height>
                <v-flex class="text-xs-center" v-if="!$vuetify.breakpoint.smOnly" style="justify-content: center; display: flex;">
                  <!-- <video id="video" width="850" controls disablePictureInPicture controlsList="nodownload">
                    <source :src="item.message" :type="'video/' + extension()">
                  </video> -->
                  <video v-if="checktype_video(item.message) === 'media'" style="width: 850px !important;" controls disablePictureInPicture controlsList="nodownload">
                    <source :src="item.message" :type="'video/' + item.message.split('.')[item.message.split('.').length - 1]">
                  </video>
                  <vplayer
                    v-else
                    style="width: 850px !important;"
                    :playerOptions="{
                      type: 'application/x-mpegURL',
                      src: item.message,
                      preload: true,
                      autoplay: false,
                      isLoop: false,
                      playsinline: false,
                      poster: item.thumbnail,
                      controls: 'progress,current,durration,volume',
                      crossOrigin: false
                    }"
                    @onplay="play"
                  />
                </v-flex>
                <v-flex class="text-xs-center" v-else style="justify-content: center; display: flex;">
                  <!-- <video id="video" width="500" controls disablePictureInPicture controlsList="nodownload">
                    <source :src="item.message" :type="'video/' + extension()">
                  </video> -->
                  <video v-if="checktype_video(item.message) === 'media'" style="width: 500px !important;" controls disablePictureInPicture controlsList="nodownload">
                    <source :src="item.message" :type="'video/' + item.message.split('.')[item.message.split('.').length - 1]">
                  </video>
                  <vplayer
                    v-else
                    style="width: 500px !important;"
                    :playerOptions="{
                      type: 'application/x-mpegURL',
                      src: item.message,
                      preload: true,
                      autoplay: false,
                      isLoop: false,
                      playsinline: false,
                      poster: item.thumbnail,
                      controls: 'progress,current,durration,volume',
                      crossOrigin: false
                    }"
                    @onplay="play"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 shrink pa-1 justify-center align-center style="background-color:white; height: 100vh;">
              <v-layout style="margin-top: 1.5em; margin-left: 1em; ">
                <v-flex xs3 sm3 md3 lg2 xl2  style=" margin-right: 20px;">
                  <v-avatar size="50" v-if="$vuetify.breakpoint.smOnly" class="user-photo">
                    <img v-if="item.path_pic" :src="item.path_pic" class="alligator-turtle">
                    <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
                  </v-avatar>
                  <v-avatar size="50" v-if="$vuetify.breakpoint.mdOnly">
                    <img v-if="item.path_pic" :src="item.path_pic" class="alligator-turtle">
                    <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
                  </v-avatar>
                  <v-avatar size="50" v-if="$vuetify.breakpoint.lgAndUp" >
                    <img v-if="item.path_pic" :src="item.path_pic" class="alligator-turtle">
                    <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
                  </v-avatar>
                </v-flex>
                <v-flex xs8 style="margin-top: 0.3em;"  v-if="$vuetify.breakpoint.mdAndDown">
                  <h4 class="web" style="margin-right:3%;">{{item.nickname}}</h4>
                  <p style="color: #383838; font-size: 11px; margin-top: 0.5em;">วันที่ส่ง&nbsp;{{datethai(item.timestamp)}} &nbsp;<v-icon style="font-size:13px !important; color: #383838 !important;">schedule</v-icon> {{ timethai(item.timestamp) }} น.</p>
                </v-flex>
                <v-flex xs8 style="margin-top: 0.3em;" v-else-if="$vuetify.breakpoint.lgOnly">
                  <h4 class="web" style="margin-right:3%;">{{item.nickname}}</h4>
                  <p style="color: #383838; font-size: 11px; margin-top: 0.5em;">วันที่ส่ง&nbsp;{{datethai(item.timestamp)}} &nbsp;<v-icon style="font-size:13px !important; color: #383838 !important;">schedule</v-icon> {{ timethai(item.timestamp) }} น.</p>
                </v-flex>
                <v-flex xs8 style="margin-top: 0.3em;" v-else-if="$vuetify.breakpoint.xlOnly">
                  <h4 class="web" style="margin-right:3%;">{{item.nickname}}</h4>
                  <p style="color: #383838; font-size: 11px; margin-top: 0.5em;">วันที่ส่ง&nbsp;{{datethai(item.timestamp)}} &nbsp;<v-icon style="font-size:13px !important; color: #383838 !important;">schedule</v-icon> {{ timethai(item.timestamp) }} น.</p>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3 md3 lg3 xl3>
                </v-flex>
                <v-flex xs9 sm9 md9 xl9 lg9 class="ml-10 mt-2">
                  <v-btn small class="buttonsubmit" @click="downloadURI(item)" :loading="loading" :disabled="loading">
                    <v-icon>file_download</v-icon>&nbsp; บันทึก
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-divider class="mt-3 mr-2 ml-2"></v-divider>
            </v-flex>
          </v-layout>
        </v-layout>

        <v-layout row wrap style="height: 50vh;" v-if="$vuetify.breakpoint.height > 500 && $vuetify.breakpoint.width < 600">
          <v-flex xs12 v-for="(item,index) in pathvideo" :key="index">
            <v-btn style="padding-top: 1em;" dark flat icon class="CloseIcon" @click="close_video()"><v-icon>close</v-icon></v-btn>
            <v-layout style="padding-top: 5em; padding-left: 0.5em;">
              <v-flex xs1 sm1 md1></v-flex>
              <v-flex xs10 sm10 md10 style="padding-top: 0.8em;">
                <h4 class="mobile" style="padding-right:8%;">{{item.nickname}}</h4>
              </v-flex>
              <v-flex xs2 sm2 md2>
                <v-btn flat icon dark @click="downloadURI(item)" :loading="loading" :disabled="loading">
                  <v-icon>file_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center justify-center>
              <v-flex class="text-xs-center" style="justify-content: center; display: flex;">
                <video v-if="checktype_video(item.message) === 'media'" style="width: 300px !important; height: 250px !important;" controls disablePictureInPicture controlsList="nodownload">
                  <source :src="item.message" :type="'video/' + item.message.split('.')[item.message.split('.').length - 1]">
                </video>
                <vplayer
                  v-else
                  style="width: 300px !important; height: 250px !important;"
                  :playerOptions="{
                    type: 'application/x-mpegURL',
                    src: item.message,
                    preload: true,
                    autoplay: false,
                    isLoop: false,
                    playsinline: false,
                    poster: item.thumbnail,
                    controls: 'progress,current,durration,volume',
                    crossOrigin: false
                  }"
                  @onplay="play"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap style="height: 100vh;" v-if="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.height < 500">
          <v-flex xs12 v-for="(item,index) in pathvideo" :key="index">
            <v-btn fab dark small class="CloseIcon" @click="close_video()"><v-icon>close</v-icon></v-btn>
            <v-layout style="padding-top: 5em;">
              <v-flex xs7 sm7 style="padding-left: 2em; padding-top: 0.8em;">
                <h4 class="mobile">{{item.nickname}}</h4>
              </v-flex>
              <v-flex xs2 sm2 style="padding-left: 6em;">
                <v-btn flat icon dark @click="downloadURI(item)" :loading="loading" :disabled="loading">
                  <v-icon>file_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center justify-center style="padding-top: 1em;">
              <!-- <v-flex class="text-xs-center">
                <video style="width: 300px !important; height: 150px !important;" controls disablePictureInPicture controlsList="nodownload">
                  <source :src="item.message" :type="'video/' + extension()">
                </video>
              </v-flex> -->
              <v-flex class="text-xs-center" style="justify-content: center; display: flex;">
                <video v-if="checktype_video(item.message) === 'media'" style="width: 300px !important; height: 250px !important;" controls disablePictureInPicture controlsList="nodownload">
                  <source :src="item.message" :type="'video/' + item.message.split('.')[item.message.split('.').length - 1]">
                </video>
                <vplayer
                  v-else
                  style="width: 300px !important; height: 250px !important;"
                  :playerOptions="{
                    type: 'application/x-mpegURL',
                    src: item.message,
                    preload: true,
                    autoplay: false,
                    isLoop: false,
                    playsinline: false,
                    poster: item.thumbnail,
                    controls: 'progress,current,durration,volume',
                    crossOrigin: false
                  }"
                  @onplay="play"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { Momenttime } from '@/services'
import { vplayer } from 'vue-hls-player'
export default {
  props: {
    infor_video: {},
    chatdialog_video: Boolean
  },
  components: {
    vplayer
  },
  data () {
    return {
      listimageinroom: [],
      tokenuser: '',
      tokenroom: '',
      pathvideo: [],
      loading: false
    }
  },
  watch: {
    chatdialog_video () {
      if (this.chatdialog_video === true) {
        this.pathvideo.push(this.infor_video)
        // this.extension()
      }
    }
  },
  methods: {
    play (e) {
      console.log(e)
    },
    checktype_video (path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4', 'divx', 'dat']
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
      if (pdf.includes(extension)) {
        return 'pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (media.includes(extension)) {
        return 'media'
      } else if (audio.includes(extension)) {
        return 'audio'
      } else {
        return 'fas fa-file-alt'
      }
    },
    downloadURI (item) {
      this.loading = true
      if (this.checktype_video(item.message) !== 'media') {
        this.axios.get(item.original_file, {
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', item.file_name)
          document.body.appendChild(link)
          link.click()
          this.loading = false
        })
      } else {
        this.axios.get(item.message, {
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', item.file_name)
          document.body.appendChild(link)
          link.click()
          this.loading = false
        })
      }
    },
    extension () {
      var extension = this.infor_video.file_name.split('.')[this.infor_video.file_name.split('.').length - 1].toLowerCase()
      return extension
    },
    datethai (timeSend) {
      return Momenttime.momentdatethai(timeSend)
    },
    timethai (timeSend) {
      return Momenttime.momenttimethai(timeSend)
    },
    close_video () {
      this.pathvideo = []
      this.$emit('closeVideodialog', false)
    }
  }
}
</script>
<style scoped>
.buttonsubmit {
  background-color: #ffffffde !important;
  color: green !important;
  width: 105px !important;
  border-radius: 50px !important;
  padding: .75em;
  border: 1px green solid;
  background: linear-gradient(to right, #077629, #077629);
  background-repeat: no-repeat;
  background-size: 0 100%;
  transition: background-size 0.2s 0s;
}
.buttonsubmit:hover {
  background-size: 100% 100%;
  color: white !important;
  border: none !important;
}
.web {
  width: 60%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* padding: 20px; */
  /* font-size: 1.3rem; */
  margin: 0;
  background-color: white;
}
.mobile {
  width: 60%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* padding: 20px; */
  /* font-size: 1.3rem; */
  margin: 0;
  color: white;
}
.CloseIcon {
  position: absolute;
  margin-top: 2%;
  margin-left: 2%;
}
</style>
